import { FC } from "preact/compat";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import { useApp } from "~/core";
import { me } from "~/core/store";
import { prettyNum } from "~/utils";
import { ApprovalLinkProps, ApprovalWidgetView } from "./interfaces";

const getSupplier = (approval: ApprovalWidgetView) =>
    approval.employee?.name ||
    approval.employee?.preferred_username ||
    approval.supplier?.internal_name ||
    approval.supplier?.name ||
    approval.project?.name;

const ApprovalLink: FC<ApprovalLinkProps> = ({ approval }) => {
    const { api } = useApp();
    const currencyCode = api.currency.base.value?.code;

    return (
        <Link
            key={approval.id}
            to={me(`admin/approval?approval=${approval.id}`)}
            className="block border border-gray-200 rounded-md px-3 py-1 hover:bg-sky-50"
        >
            <div className="flex items-center justify-between">
                <p className="truncate">
                    <span>{getSupplier(approval)}</span>
                </p>
                <span className="whitespace-nowrap text-sm font-bold">
                    {prettyNum(approval.amount)} {currencyCode}
                </span>
            </div>
            <div className="flex items-center justify-between text-xs mt-1">
                <span>
                    {approval.dueDate
                        ? format(approval.dueDate, "dd MMM")
                        : "N/A"}
                </span>
                <span className="text-gray-500">Open</span>
            </div>
        </Link>
    );
};

export default ApprovalLink;
